 function circleAnimation(selector,size,color,value){
  jQuery(selector).waypoint(function () {
    $.getScript("https://cdn.shopify.com/s/files/1/1235/7388/t/141/assets/counter.js").done(function() {
   jQuery(selector).circleProgress({
        startAngle: -Math.PI / 2 * 1,
        value: (value/100),
        lineCap: 'square',
        fill: { color: color },
        size: size,

    })
   });
    jQuery(selector).on('circle-animation-progress', function (event, progress) {
        jQuery(this).find('strong').html(Math.round(value * progress));
    }); 
    this.destroy();
  }, { offset: '75%' });
}

function circleDropAnimation(selector,size,color,value){
 jQuery(selector).waypoint(function () {
  $.getScript("https://cdn.shopify.com/s/files/1/1235/7388/t/141/assets/counter.js").done(function() {
  jQuery(selector).circleProgress({
        startAngle: -Math.PI / 2 * 1,
        value: (value/100),
        lineCap: 'square',
        fill: { color: color },
        size: size,
        thickness: '15',
        emptyFill: 'rgb(255, 255, 255, .28)',

    })
   })
  jQuery(selector).on('circle-animation-progress', function (event, progress) {
        jQuery(this).find('strong').html(Math.round(value * progress));
    });
  this.destroy(); 
  }, { offset: '75%' });
   
}

function makeRandomId(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}


function startImageAnimation(selector){
   jQuery(selector).waypoint(function () {
     //console.log('test1');
     jQuery(selector).each(function(){
        var img_src = jQuery(this).attr('img-src');
        let version = makeRandomId(15); 
         jQuery(this).attr('src', img_src+'?'+version);
          jQuery(this).show();
        //console.log('test2');
      });
      this.destroy();
    }, { offset: '75%' });
}

 if(jQuery('.svg-animation-image-icon').length != 'undefined'){ 
     startImageAnimation('.svg-animation-image-icon');
 }  
//  if(jQuery('.svg-animation-image-column').length != 'undefined'){
//     startImageAnimation('.svg-animation-image-column');
//  }
//  if(jQuery('.column-hero-animation-img').length != 'undefined'){
//       startImageAnimation('.column-hero-animation-img');
//  }
//  if(jQuery('.svg-animation-image-map').length != 'undefined'){
//     startImageAnimation('.svg-animation-image-map');
//  }

 if(jQuery('.svg-animation-image-report-2').length != 'undefined'){
    startImageAnimation('.svg-animation-image-report-2');
 }
  if(jQuery('.svg-animation-image-report-3').length != 'undefined'){
    startImageAnimation('.svg-animation-image-report-3');
 }

 if(jQuery('.svg-animation-image-column-hero').length != 'undefined'){
    startImageAnimation('.svg-animation-image-column-hero');
 }


// if(jQuery('.svg-animation-image-column-science').length != 'undefined'){
//     startImageAnimation('.svg-animation-image-column-science');
//  }


function headingBorderAnimation(selector){
   jQuery(selector).waypoint(function () {
    jQuery(selector).each(function(){
        jQuery(this).addClass('border-animation-started');
      });
      this.destroy();
    }, { offset: '75%' });
}


if(jQuery('.heading-border-top-animation').length != 'undefined'){
    headingBorderAnimation('.heading-border-top-animation');
 }
if(jQuery('.heading-border-bottom-animation').length != 'undefined'){
    headingBorderAnimation('.heading-border-bottom-animation');
 }




function yellowStripAnimation(selector){
   var ppWaypoint = $(selector).waypoint(function(direction) {
        //check the direction
        if(direction == 'down') {
            $(this.element).addClass('yellow-strip-animation-started');
            this.destroy();
        }
    }, {
        offset: '75%'
    });
}



// function yellowStripAnimation(selector){
//      jQuery(selector).each(function(){
//         var self = jQuery(this);
//          jQuery(this).waypoint({
//                  handler: function(){
//                      self.addClass('yellow-strip-animation-started');
//                    //console.log(self);
//                    this.destroy();
//                  }
           
//     }, { offset: '75%' });
//         })     
// }

if(jQuery('.yellow-strip').length != 'undefined'){
    yellowStripAnimation('.yellow-strip');
  
}
if(jQuery('.yellow-strip-team').length != 'undefined'){
    yellowStripAnimation('.yellow-strip-team');  
}

if(jQuery('.yellow-bg-strip').length != 'undefined'){
    yellowStripAnimation('.yellow-bg-strip');
}

if(jQuery('.animation-strip').hasClass('yellow-strip-animation-started') == false){
    $.getScript( "https://cdn.shopify.com/s/files/1/1235/7388/t/141/assets/jquery.waypoints.min.js", function() {
     $('.animation-strip').waypoint(function(direction) {
        //check the direction
        if(direction == 'down') {
            $(this.element).addClass('yellow-strip-animation-started');
            this.destroy();
        }
    }, {
        offset: '75%'
    });
   });
}
